import { Pipe, PipeTransform, Input } from "@angular/core";

@Pipe({ name: "priceFormatter" })
export class PriceFormatterPipe implements PipeTransform {
  transform(value: number | string): any {
    return Intl.NumberFormat().format(Number(value));
  }
}
